import { Component } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Api, ErrorCodes, ErrorHelper, Session, Ui } from '../services/index';

@Component({
    selector: 'signup-plan',
    templateUrl: 'signup-plan.html'
})
export class SignupPlan {
  planFormGroup: FormGroup;
  submitted: boolean;
  processing: boolean = false;

  constructor(private api: Api,
              private errorHelper: ErrorHelper,
              private fb: FormBuilder,
              private router: Router,
              private session: Session,
              private ui: Ui) {
    this.planFormGroup = this.fb.group({
        'planCode': new FormControl(this.session.patient.planCode)
        });
        console.dir(this.session);
  }
     
  get planCode() { return this.planFormGroup.get('planCode'); }

  continue(plan:boolean = false) {
    if(plan && this.planFormGroup['planCode']){
      this.session.patient.planCode = this.planFormGroup['planCode'];
    }else{
      this.session.patient.planCode = '';
    }
    document.body.style.cursor = "wait";
    this.processing = true;
    this.requesting(true);
    if(! this.session.patient.parentRelationship || this.session.patient.parentRelationship.length === 0){
      this.session.patient.parentRelationship = '18';
    }
		this.session.createPatient(this.session.patient).subscribe(response => {
      this.session.login(this.session.patient.email, this.session.patient.password)
        .subscribe(success => {
          this.session.setAuthenticated(true);
          this.requesting(false);
          this.router.navigate(['/dashboard']);
          this.processing = false;
          document.body.style.cursor = "default";
        }, ex => {
          console.log('Invalid Login Credentials');
          this.requesting(false);
          this.processing = false;
          document.body.style.cursor = "default";
        });
		}, ex => {
			var error = this.errorHelper.toError(ex);
			if(error.errorCode == ErrorCodes.PLAN_IDENTIFIER_NOT_FOUND){
				this.planFormGroup.controls['planCode'].setErrors({ 'server': 'Plan not found'})
			} else {
				this.errorHelper.handleServerValidation(this.planFormGroup, ex)
			}
      this.requesting(false);
      this.processing = false;
      document.body.style.cursor = "default";
		});
  }
  
  requesting(requesting: boolean){
      this.ui.showLoadingIndicator(requesting);
      this.submitted = requesting;
  }
}